var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// @ts-nocheck
import * as React from 'react';
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Datagrid, List, TextField, FunctionField, useDataProvider, useNotify, useRefresh, } from 'react-admin';
import { Typography, Grid, Button, Zoom, } from '@mui/material';
// individual panel component
var PanelComp = function (_a) {
    var icon = _a.icon, text = _a.text, setClickedPanelComp = _a.setClickedPanelComp, backgroundColor = _a.backgroundColor;
    return (_jsxs(Grid, { item: true, display: "flex", flexWrap: "wrap", alignItems: "center", padding: 0.5, style: {
            cursor: "pointer",
            backgroundColor: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "white"
        }, onClick: function () { }, children: [_jsx(Typography, { variant: "body", sx: { paddingRight: "0.5rem" }, children: icon }), _jsx(Typography, { variant: "body", children: text })] }));
};
var classes = {
    noMarginDialog: {
        '&>div:nth-child(3)': {
            '&>div': {
                margin: 0,
            },
        },
    }
};
var Transition = React.forwardRef(function Transition(props, ref) {
    return _jsx(Zoom, __assign({ ref: ref }, props));
});
var UserComp = function (_a) {
    var generalData = _a.generalData, data = _a.data, params = _a.params, translate = _a.translate, filters = _a.filters, setFilters = _a.setFilters, closeDialog = _a.closeDialog, opened = _a.opened, reloadRecord = _a.reloadRecord, setDialogData = _a.setDialogData;
    var _b = useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var location = useLocation();
    var navigate = useNavigate();
    var dataProvider = useDataProvider();
    var notify = useNotify();
    var refresh = useRefresh();
    return (_jsx(_Fragment, { children: _jsx(Grid, { item: true, display: "flex", flexWrap: "wrap", alignItems: "start", justifyContent: "start", width: "100%", backgroundColor: "", children: _jsx(List, { resource: "organizations", style: { width: "100%", backgroundColor: "" }, children: _jsxs(Datagrid, { data: data, style: { backgroundColor: "green" }, children: [_jsx(TextField, { source: "id", label: "Group ID" }), _jsx(TextField, { source: "username", label: translate("pages.userList.fields.username") }), _jsx(TextField, { source: "Last_name", label: translate("pages.subject.fields.lastname") }), _jsx(TextField, { source: "First_name", label: translate("pages.subject.fields.firstname") }), _jsx(TextField, { source: "email", label: translate("pages.userList.fields.email") }), _jsx(TextField, { source: "gender", label: translate("pages.subject.fields.gender") }), _jsx(FunctionField, { source: "userGroup", label: translate("pages.userList.fields.userGroup"), render: function (record) {
                                var _a;
                                return (_jsxs(Typography, { style: {}, children: [console.log(record.userGroups, '==log userGroup '), (_a = record.userGroups) === null || _a === void 0 ? void 0 : _a.map(function (item) { return item.name; }).join(', ')] }));
                            } }), _jsx(FunctionField, { source: "status", label: translate("pages.userList.fields.status"), render: function (record) {
                                var _a;
                                var bgColor;
                                switch (record.status) {
                                    case ("Disabled" || "disabled"):
                                        bgColor = "red";
                                        break;
                                    default:
                                        bgColor = "green";
                                        break;
                                }
                                return (_jsx(Button, { style: {
                                        backgroundColor: bgColor,
                                        paddingY: 0,
                                        pointer: "none",
                                        color: "white", ':hover': {
                                            background: 'none'
                                        },
                                        textTransform: 'none'
                                    }, children: (_a = record.status) !== null && _a !== void 0 ? _a : "Active" }));
                            } })] }) }) }) }));
};
export default UserComp;
